/**
 * Форматирование дат календаря.
 *
 * Модуль намеренно ни от чего не зависит: его собирают отдельно в тестах
 * (`test/javascript/date_format_test.cjs`), где нет ни DOM, ни flatpickr.
 */

/** Месяцы в родительном падеже — «25 августа», а не «25 август». */
const MONTHS_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря'
]

/**
 * Дата в виде «2026-08-25» по местному времени.
 *
 * Date#toISOString здесь не годится: он переводит время в UTC, и выбранная
 * в календаре полночь 25 августа по Москве превращается в 24 августа 21:00 —
 * день уезжает на сутки назад. Так было во всех поясах восточнее Гринвича.
 *
 * @param {Date} date - Дата, выбранная в календаре.
 * @return {string} Дата в формате ISO без времени.
 */
export function formatDateParam(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

/**
 * Подпись кнопки календаря: «25 августа» или «25 августа — 3 сентября».
 *
 * @param {Date[]} dates - Выбранные даты: одна или начало и конец диапазона.
 * @param {string} fallback - Что показать, если ничего не выбрано.
 * @return {string} Готовая подпись.
 */
export function formatDateRangeLabel(dates: Date[], fallback: string): string {
  const [from, to] = dates.filter(Boolean)

  if (!from) {
    return fallback
  }

  if (!to || formatDateParam(from) === formatDateParam(to)) {
    return formatDayAndMonth(from)
  }

  // Внутри одного месяца он называется единожды: «1 — 5 сентября».
  const sameMonth =
    from.getFullYear() === to.getFullYear() && from.getMonth() === to.getMonth()
  const start = sameMonth ? String(from.getDate()) : formatDayAndMonth(from)

  return `${start} — ${formatDayAndMonth(to)}`
}

function formatDayAndMonth(date: Date): string {
  return `${date.getDate()} ${MONTHS_GENITIVE[date.getMonth()]}`
}
